import { gql, TypedDocumentNode } from "@apollo/client";
import { CRM_TASK_FIELDS_FRAGMENT } from "@/fragments";
import type { CRMTask } from "@/types";

export type TaskQueryResponse = {
  task: CRMTask;
};

export const GET_TASK_QUERY: TypedDocumentNode<TaskQueryResponse> = gql`
  query GetTask($id: ID!) {
    task(id: $id) {
      ...CRMTaskFields
      commentsCount
      comments {
        id
        content
        authorName
        createdAt
        updatedAt
        author {
          id
          name
          email
          photo
        }
      }
    }
  }
  ${CRM_TASK_FIELDS_FRAGMENT}
`;
